var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _path17, _ellipse, _path18, _ellipse2, _path19, _ellipse3, _path20, _ellipse4, _path21, _ellipse5, _path22, _ellipse6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustration404 = function SvgIllustration404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 240 240"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m47.163 84.596 2.915-7.893L64.19 67.32l-3.099 8.003z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__a)",
    d: "m47.163 84.596 8.123 6.53 14.1-9.135-8.294-6.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__b)",
    d: "m64.192 67.321 8.214 6.603-3.019 8.067-8.295-6.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m53.127 80.557-.09-.037-.026.067.055.045zm3.324-7.813a.096.096 0 1 0-.178-.073zm4.951 14.342-8.215-6.604-.12.15 8.215 6.603zm-8.187-6.492 3.236-7.85-.178-.073-3.235 7.85z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    d: "m172.251 187.267-8.032 4.685L182.96 204l7.362-8.032z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    d: "m46.419 117.657-8.032 4.686 18.74 12.047 7.363-8.031z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "m172.589 160.505 9.905 2.929 12.639 16.527-10.054-3.146z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__e)",
    d: "m172.589 160.505-7.338 10.482 12.335 16.53 7.493-10.702z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__f)",
    d: "m195.133 179.961-7.42 10.598-10.127-3.042 7.493-10.702z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5CCB",
    d: "m178.021 167.482.037-.111-.083-.028-.051.072zm9.84 3.437a.117.117 0 0 0 .149-.073.117.117 0 0 0-.074-.149zm-17.165 7.231 7.421-10.6-.193-.135-7.421 10.6zm7.287-10.556 9.878 3.325.075-.222-9.878-3.326z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__g)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    d: "M59.691 153.559c-2.19-1.256-1.583-4.569.912-4.966l105.359-16.762c2.114-.336 3.748 1.821 2.853 3.765l-28.136 61.06a2.677 2.677 0 0 1-3.764 1.202z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__h)",
    d: "M59.691 134.818c-2.19-1.256-1.583-4.569.912-4.966l105.359-16.762c2.114-.336 3.748 1.821 2.853 3.765l-28.136 61.06a2.677 2.677 0 0 1-3.764 1.202z",
    opacity: 0.9
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__i)",
    d: "M59.691 122.771c-2.19-1.257-1.583-4.57.912-4.967l105.359-16.762c2.114-.336 3.748 1.821 2.853 3.765l-28.136 61.061a2.678 2.678 0 0 1-3.764 1.202z",
    opacity: 0.9
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "M59.691 112.061c-2.19-1.256-1.583-4.569.912-4.966l105.359-16.762c2.114-.336 3.748 1.821 2.853 3.765l-28.136 61.06a2.677 2.677 0 0 1-3.764 1.202z",
    opacity: 0.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__j)",
    d: "M101.937 119.412c-.861.091-1.707.29-2.518.592-2.968 1.096-4.16 3.053-2.55 4.663a6.513 6.513 0 0 0 5.364 1.384 11 11 0 0 0 2.579-.612c3.059-1.135 4.179-3.007 2.534-4.662a6.722 6.722 0 0 0-5.409-1.365m50.703-18.405-39.922 15.67 3.104 3.135 41.209-14.397-4.39-4.393"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.937 116.278c-.861.091-1.707.29-2.518.592-2.968 1.097-4.16 3.053-2.55 4.664a6.522 6.522 0 0 0 5.364 1.384c.881-.1 1.747-.305 2.579-.613 3.059-1.134 4.179-3.007 2.534-4.662a6.715 6.715 0 0 0-5.409-1.365m50.703-18.405-39.922 15.67 3.104 3.136 41.209-14.398-4.39-4.392"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__k)",
    d: "M191.365 113.346c3.9-11.577.541-13.595.096-18.617l15.765 1.565c-1.418 4.827-5.128 6.158-3.566 18.277.886 4.27 1.137 9.796.542 15.785-1.287 12.97-6.008 23.088-10.556 22.632-4.548-.456-7.183-11.313-5.898-24.265.577-5.995 1.909-11.36 3.617-15.377"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__l)",
    d: "m189.705 97.672.337-3.404c.137-1.377 1.169-2.67 3.102-3.54 3.845-1.737 9.743-1.147 13.181 1.308 1.716 1.232 2.487 2.695 2.36 4.073l-.339 3.413c-.137 1.382-1.169 2.675-3.102 3.544-3.845 1.737-9.743 1.143-13.176-1.307-1.721-1.233-2.497-2.696-2.365-4.074z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "M193.209 90.088c3.844-1.736 9.747-1.142 13.18 1.308s3.107 5.873-.755 7.604c-3.861 1.73-9.738 1.147-13.18-1.309-3.442-2.455-3.09-5.866.755-7.603"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__m)",
    d: "M201.113 96.22a2.988 2.988 0 0 1-2.683-.266.944.944 0 0 1-.482-.83l4.88-49.17-.063-.046-.939-3.508 2.483-5.548 2.804 2.012-.081 7.273-1.459 1.784-4.805 48.414c.118-.028.234-.067.345-.115"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__n)",
    d: "M202.147 96.314a2.99 2.99 0 0 1-2.684-.266.958.958 0 0 1-.482-.83l4.88-49.17-.063-.047-.939-3.507 2.484-5.549 2.804 2.013-.081 7.273-1.46 1.783-4.805 48.415c.119-.029.234-.067.346-.115"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__o)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.346,
    cy: 161.163,
    fill: "#E9E7F6",
    rx: 10.709,
    ry: 3.347
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__p)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    d: "M53.8 186.919c1.996-.431 4.418.064 5.767 1.109a9.22 9.22 0 0 0 2.498-1.848c-1.689-.795-2.664-2.365-2.23-3.742.436-1.377 2.146-2.084 3.98-1.746a9.208 9.208 0 0 0-.955-2.957c-1.704.065-3.956-.943-5.333-2.459-1.378-1.517-1.386-3.009-.143-3.581a27.709 27.709 0 0 0-3.842-2.335c-.724.888-2.94 1.029-5.325.263-2.385-.766-4.106-2.175-4.178-3.32a27.88 27.88 0 0 0-4.48-.339c.682 1.191-.2 2.399-2.194 2.83-1.995.431-4.416-.064-5.766-1.109a9.227 9.227 0 0 0-2.497 1.847c1.687.796 2.664 2.365 2.229 3.743-.436 1.378-2.147 2.084-3.981 1.747a9.182 9.182 0 0 0 .96 2.959c1.704-.064 3.956.944 5.333 2.46 1.378 1.517 1.385 3.007.143 3.581a27.687 27.687 0 0 0 3.84 2.335c.725-.888 2.943-1.03 5.326-.264 2.382.767 4.107 2.175 4.178 3.32 1.482.233 2.98.347 4.48.34-.682-1.194.196-2.403 2.19-2.834m-16.67-7.236c-3.21-3.543-2.03-7.232 2.639-8.241 4.668-1.009 11.055 1.044 14.263 4.58 3.207 3.537 2.03 7.232-2.637 8.241-4.668 1.009-11.052-1.038-14.264-4.58"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__q)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.803,
    cy: 178.188,
    fill: "#E9E7F6",
    rx: 6.217,
    ry: 3.73,
    transform: "rotate(17.804 45.803 178.188)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__r)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7F6",
    d: "M164.071 77.267c.998-1.065 2.622-1.76 3.84-1.694a6.614 6.614 0 0 0 .717-2.102c-1.316.219-2.528-.307-2.832-1.293-.305-.986.413-2.098 1.629-2.646a6.586 6.586 0 0 0-1.765-1.35c-.975.732-2.709 1.056-4.135.724-1.427-.33-2.038-1.204-1.541-2.046a19.76 19.76 0 0 0-3.207.19c-.065.816-1.31 1.8-3.024 2.32-1.713.52-3.299.392-3.806-.251a19.835 19.835 0 0 0-2.771 1.622c.885.423.858 1.492-.139 2.557-.998 1.064-2.622 1.758-3.841 1.693a6.581 6.581 0 0 0-.716 2.101c1.315-.218 2.528.307 2.833 1.294.304.987-.415 2.098-1.63 2.646a6.552 6.552 0 0 0 1.768 1.349c.976-.731 2.709-1.054 4.136-.723 1.426.331 2.037 1.204 1.54 2.046 1.073.024 2.145-.039 3.207-.19.065-.816 1.311-1.801 3.024-2.32 1.712-.519 3.298-.392 3.806.252a20.033 20.033 0 0 0 2.771-1.623c-.886-.424-.861-1.492.136-2.556m-12.743 2.526c-3.328-.776-4.135-3.425-1.801-5.917 2.333-2.491 6.923-3.883 10.247-3.109 3.324.775 4.136 3.425 1.802 5.917s-6.919 3.885-10.248 3.11"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-404_svg__s)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.818,
    cy: 75.387,
    fill: "#E9E7F6",
    rx: 4.444,
    ry: 2.666,
    transform: "rotate(-16.879 155.818 75.387)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__t)",
    d: "m67.097 171.273 1.777-5.534a9.308 9.308 0 0 0-.967-2.985c-1.72.065-3.992-.953-5.381-2.483a4.432 4.432 0 0 1-.871-1.354l.724-2.256a28.076 28.076 0 0 0-3.875-2.355c-.73.896-2.968 1.039-5.374.265-2.406-.774-4.143-2.195-4.215-3.348a27.921 27.921 0 0 0-4.52-.344l-.727 2.265c-.456.287-.96.489-1.489.596-2.01.428-4.456-.065-5.818-1.12a9.346 9.346 0 0 0-2.518 1.863l-2.12 6.601-1.777 5.535a9.235 9.235 0 0 0 .969 2.985c1.719-.064 3.99.953 5.381 2.482.37.395.664.854.87 1.354l-.725 2.257a27.922 27.922 0 0 0 3.875 2.356c.73-.896 2.968-1.04 5.373-.265 2.404.774 4.142 2.193 4.214 3.349a28.4 28.4 0 0 0 4.521.343l.727-2.264c.456-.287.96-.489 1.49-.596 2.012-.435 4.456.064 5.817 1.119a9.372 9.372 0 0 0 2.52-1.864l2.12-6.601zm-10.756-1.924c-4.71 1.018-11.156-1.055-14.398-4.624a8.614 8.614 0 0 1-.947-1.259 8.737 8.737 0 0 1 1.492-.463c4.71-1.018 11.155 1.054 14.395 4.629.354.389.671.808.95 1.254a8.65 8.65 0 0 1-1.492.463"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.31,
    cy: 166.581,
    fill: "url(#illustration-404_svg__u)",
    rx: 6.217,
    ry: 3.73,
    transform: "rotate(17.804 49.31 166.581)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "M58.35 171.729c1.995-.43 4.416.064 5.765 1.109a9.22 9.22 0 0 0 2.498-1.848c-1.688-.795-2.664-2.365-2.229-3.741.435-1.377 2.146-2.084 3.98-1.747a9.208 9.208 0 0 0-.955-2.957c-1.704.066-3.956-.943-5.333-2.459-1.378-1.517-1.386-3.009-.144-3.581a27.703 27.703 0 0 0-3.84-2.335c-.725.888-2.941 1.029-5.326.263-2.385-.766-4.107-2.175-4.178-3.319a27.767 27.767 0 0 0-4.48-.34c.682 1.191-.2 2.399-2.194 2.83-1.995.431-4.416-.064-5.766-1.109a9.226 9.226 0 0 0-2.497 1.847c1.687.796 2.664 2.365 2.229 3.743-.436 1.378-2.147 2.084-3.981 1.747a9.164 9.164 0 0 0 .96 2.959c1.704-.064 3.956.944 5.333 2.46 1.377 1.517 1.385 3.008.143 3.581a27.692 27.692 0 0 0 3.84 2.335c.724-.888 2.943-1.03 5.326-.263 2.382.766 4.107 2.174 4.178 3.319a28 28 0 0 0 4.48.34c-.682-1.194.196-2.402 2.19-2.834m-16.67-7.236c-3.212-3.543-2.03-7.232 2.637-8.241 4.668-1.009 11.056 1.044 14.263 4.581 3.207 3.536 2.031 7.232-2.637 8.24-4.668 1.009-11.051-1.038-14.264-4.58"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.577,
    cy: 162.635,
    fill: "#5F8FFF",
    rx: 6.217,
    ry: 3.73,
    transform: "rotate(17.804 50.577 162.635)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-404_svg__v)",
    d: "m165.522 62.66-1.206-3.975a6.649 6.649 0 0 0-1.784-1.361c-.984.737-2.733 1.064-4.172.73a3.17 3.17 0 0 1-1.063-.442l-.492-1.621a20.107 20.107 0 0 0-3.236.191c-.065.825-1.322 1.818-3.051 2.342s-3.328.395-3.84-.254c-.975.47-1.91 1.017-2.796 1.637l.493 1.627a3.177 3.177 0 0 1-.632.956c-1.008 1.07-2.646 1.775-3.876 1.708a6.644 6.644 0 0 0-.722 2.12l1.439 4.742 1.206 3.977a6.603 6.603 0 0 0 1.784 1.36c.985-.737 2.734-1.063 4.173-.73.378.083.737.232 1.062.442l.492 1.622c1.082.025 2.164-.04 3.236-.19.065-.825 1.322-1.82 3.05-2.342 1.729-.523 3.328-.396 3.84.254.975-.47 1.91-1.018 2.797-1.637l-.493-1.627c.151-.354.365-.678.633-.955 1.006-1.075 2.645-1.776 3.875-1.71a6.704 6.704 0 0 0 .723-2.12l-1.439-4.743zm-7.105 3.245c-2.355 2.514-6.987 3.918-10.344 3.139a6.122 6.122 0 0 1-1.069-.355c.202-.313.433-.607.688-.879 2.355-2.514 6.986-3.919 10.345-3.134.366.084.723.201 1.068.35a6.27 6.27 0 0 1-.688.88"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.158,
    cy: 67.138,
    fill: "url(#illustration-404_svg__w)",
    rx: 4.444,
    ry: 2.666,
    transform: "rotate(-16.879 153.158 67.138)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F8FFF",
    d: "M160.566 66.487c.998-1.065 2.623-1.759 3.841-1.693a6.614 6.614 0 0 0 .717-2.102c-1.316.219-2.528-.307-2.833-1.293-.304-.987.414-2.098 1.629-2.646a6.581 6.581 0 0 0-1.764-1.35c-.975.732-2.709 1.056-4.135.724-1.427-.33-2.039-1.205-1.541-2.046a19.773 19.773 0 0 0-3.208.19c-.064.816-1.31 1.8-3.023 2.32-1.714.52-3.299.392-3.806-.252a19.904 19.904 0 0 0-2.772 1.623c.886.423.858 1.491-.139 2.556s-2.621 1.76-3.84 1.694a6.581 6.581 0 0 0-.716 2.101c1.315-.218 2.528.307 2.832 1.294.305.987-.414 2.098-1.63 2.646a6.57 6.57 0 0 0 1.769 1.349c.975-.731 2.709-1.054 4.135-.723 1.427.33 2.038 1.204 1.541 2.046a19.76 19.76 0 0 0 3.207-.19c.064-.816 1.311-1.801 3.023-2.32 1.712-.519 3.299-.393 3.807.252a20.081 20.081 0 0 0 2.771-1.623c-.886-.424-.862-1.492.135-2.557m-12.742 2.527c-3.329-.776-4.135-3.425-1.802-5.917 2.334-2.492 6.924-3.883 10.248-3.109 3.323.775 4.135 3.425 1.802 5.917-2.334 2.492-6.919 3.885-10.248 3.11"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.298,
    cy: 64.303,
    fill: "#5F8FFF",
    rx: 4.444,
    ry: 2.666,
    transform: "rotate(-16.879 152.298 64.303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__a",
    x1: 52.16,
    x2: 64.389,
    y1: 78.379,
    y2: 88.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__b",
    x1: 61.63,
    x2: 71.949,
    y1: 70.509,
    y2: 78.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__e",
    x1: 180.611,
    x2: 169.564,
    y1: 166.121,
    y2: 181.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__f",
    x1: 191.021,
    x2: 181.698,
    y1: 177.082,
    y2: 190.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__h",
    x1: 69.175,
    x2: 182.96,
    y1: 152.462,
    y2: 98.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__i",
    x1: 69.175,
    x2: 182.96,
    y1: 140.414,
    y2: 86.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__j",
    x1: 126.915,
    x2: 124.819,
    y1: 130.33,
    y2: 101.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AEEA73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AEEA73",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AEEA73",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AEEA73",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AEEA73",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEEA73",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__k",
    x1: 199.352,
    x2: 193.648,
    y1: 95.513,
    y2: 152.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__l",
    x1: 199.897,
    x2: 198.491,
    y1: 89.811,
    y2: 103.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__m",
    x1: 205.157,
    x2: 199.259,
    y1: 36.936,
    y2: 96.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#3572FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__n",
    x1: 206.19,
    x2: 200.293,
    y1: 37.029,
    y2: 96.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#3572FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__t",
    x1: 44.48,
    x2: 58.167,
    y1: 180.266,
    y2: 137.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__u",
    x1: 49.31,
    x2: 49.31,
    y1: 162.851,
    y2: 170.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__v",
    x1: 155.885,
    x2: 146.595,
    y1: 77.147,
    y2: 46.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-404_svg__w",
    x1: 153.158,
    x2: 153.158,
    y1: 64.472,
    y2: 69.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__c",
    width: 36.813,
    height: 27.442,
    x: 158.864,
    y: 181.912,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.677
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__d",
    width: 36.813,
    height: 27.442,
    x: 33.032,
    y: 112.303,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.677
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__g",
    width: 121.43,
    height: 77.127,
    x: 52.99,
    y: 126.442,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.677
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__o",
    width: 32.128,
    height: 17.402,
    x: 180.283,
    y: 152.462,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.677
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__p",
    width: 50.557,
    height: 37.881,
    x: 20.304,
    y: 158.918,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 3.523
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__q",
    width: 26.15,
    height: 22.15,
    x: 32.728,
    y: 167.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 3.523
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__r",
    width: 36.221,
    height: 26.928,
    x: 137.443,
    y: 61.818,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.518
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-404_svg__s",
    width: 18.72,
    height: 15.793,
    x: 146.458,
    y: 67.491,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_92_1932",
    stdDeviation: 2.518
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustration404);
export default Memo;